import Api from './Api.service';

export default class RolService {

    static ObtenerTodo() {
        return Api.get('rolweb');
    }
    
     static Insertar(model) {
         return Api.post('rolinsertar',model);
     }
     static Editar(model) {
         return Api.put('roleditar',model);
     }
     static Eliminar(rolid) {
         return Api.delete(`rol/${rolid}`);
     }

}